import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineChart3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="line-chart-3, statistics, graph"><path d="M2.75 16.75V19.25M8.91667 12.75L8.91667 19.25M15.0827 8.75V19.25M21.2487 4.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLineChart3;
